var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCameraIconBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.5071 14.6666H11.4938C13.3338 14.6666 14.0671 13.5399 14.1538 12.1666L14.5004 6.65992C14.5938 5.21992 13.4471 3.99992 12.0004 3.99992C11.5938 3.99992 11.2204 3.76659 11.0338 3.40659L10.5538 2.43992C10.2471 1.83325 9.4471 1.33325 8.7671 1.33325H7.24044C6.55377 1.33325 5.75377 1.83325 5.4471 2.43992L4.9671 3.40659C4.78044 3.76659 4.4071 3.99992 4.00044 3.99992C2.55377 3.99992 1.4071 5.21992 1.50044 6.65992L1.8471 12.1666C1.9271 13.5399 2.6671 14.6666 4.5071 14.6666Z",
    stroke: "#004EFF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7 5.33325H9",
    stroke: "#004EFF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.99967 12.0001C9.19301 12.0001 10.1663 11.0267 10.1663 9.83341C10.1663 8.64008 9.19301 7.66675 7.99967 7.66675C6.80634 7.66675 5.83301 8.64008 5.83301 9.83341C5.83301 11.0267 6.80634 12.0001 7.99967 12.0001Z",
    stroke: "#004EFF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCameraIconBlue);
export default __webpack_public_path__ + "static/media/cameraIconBlue.944554b0f06b8c36e36a527d2182d93a.svg";
export { ForwardRef as ReactComponent };